angular
  .module('contrast.factory.organization', [])
  .factory('OrganizationFactory', function ($http, UserService) {
    return {
      getOrganization: function () {
        return $http.get(UserService.buildAPIUrl('/organizations'))
      },
      editOrganization: function (organization) {
        return $http.put(
          UserService.buildAPIUrl('/organizations'),
          organization
        )
      },
      restoreSuperadminSession: function () {
        return $http.get(UserService.buildAPIUrl('/organizations/restore'))
      },
      getScorePolicy: function () {
        return $http.get(
          UserService.buildAPIUrl('/organizations/scoring/policy')
        )
      },
      updateScorePolicy: function (form) {
        return $http.put(
          UserService.buildAPIUrl('/organizations/scoring/policy'),
          form
        )
      },
      getApplicationRoles: function (offset, limit, q) {
        return $http.get(
          UserService.buildAPIUrl('/organizations/application/roles'),
          {
            params: {
              limit: limit,
              offset: offset,
              q: q
            }
          }
        )
      },
      getApplicationStats: function (interval, expand) {
        return $http.get(
          UserService.buildAPIUrl('/organizations/stats/application'),
          {
            params: {
              expand: expand,
              interval: interval
            }
          }
        )
      },
      getLibraryStats: function (interval, expand) {
        return $http.get(
          UserService.buildAPIUrl('/organizations/stats/library'),
          {
            params: {
              expand: expand,
              interval: interval
            }
          }
        )
      },
      getServerStats: function (interval, expand) {
        return $http.get(
          UserService.buildAPIUrl('/organizations/stats/server'),
          {
            params: {
              expand: expand,
              interval: interval
            }
          }
        )
      },
      getTraceStats: function (interval) {
        return $http.get(
          UserService.buildAPIUrl('/organizations/stats/trace'),
          {
            params: {
              interval: interval
            }
          }
        )
      },
      getAdministrators: function () {
        return $http.get(
          UserService.buildAPIUrl('/organizations/administrators')
        )
      },
      getServerToRestartIfChange: function (language) {
        return $http.get(
          UserService.buildAPIUrl('/organizations/servers/restart/' + language)
        )
      },
      getOrganizationExpand: function (expandValue) {
        return $http.get(UserService.buildAPIUrl('/organizations'), {
          params: { expand: expandValue }
        })
      }
    }
  })
